import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { selectCurrentUser } from '../store/slices/authSlice';
import { getReturnUrl, clearLoggingOut } from '../util/returnUrl';
import Login from '../pages/login/Login';

/**
 * Route-level guard for the login page.
 * If the user already has a token (no 401 / session not cleared), redirect to home or returnUrl
 * so they are not shown the login screen (e.g. when using the browser back button).
 */
const LoginRouteGuard = () => {
  const user = useSelector(selectCurrentUser);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Clear manual-logout flag when landing on login so it doesn't affect future protected-route redirects
  clearLoggingOut();

  if (user) {
    const returnUrl = getReturnUrl(location, searchParams);
    return <Navigate to={returnUrl || '/'} replace />;
  }

  return <Login />;
};

export default LoginRouteGuard;
